export const normalizeCollection = (value) => {
  if (Array.isArray(value)) return value
  if (Array.isArray(value?.['hydra:member'])) return value['hydra:member']
  if (value && typeof value === 'object') return Object.values(value)
  return []
}
